module.exports = __webpack_public_path__ + "static/media/convert_to_composition.a1ca0177.jpg";